import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import 'react-datepicker/dist/react-datepicker.css';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import {
  getNewReturnCustomerData,
  handleLoader,
} from '../../../../redux/actions/NewReturnCustomer';
import { tableNewReturnCustomer, vendorNameMapping } from '../../helper';
import NewReturnCustomer from './NewReturnCustomer';
import ViewNewReturnReportModel from './ViewReportModel';

const NewReturnCustomerIndex = ({ dispatch, rtl, vendor }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const { isLoading, newReturnCustomerData, salesChannelFilterData } = useSelector(
    ({ newReturnCustomerReducer, marketPlaceReducer }) => ({
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      newReturnCustomerData: newReturnCustomerReducer?.[vendor]?.newReturnCustomerData,
      isLoading: newReturnCustomerReducer?.[vendor]?.isLoading,
    }),
  );

  const [isOpen, setIsOpen] = useState(false);
  const [newReturnCustomerDataToShow, setNewReturnCustomerDataToShow] = useState([]);

  const [filterData, setFilterData] = useState({});
  const [dateRange, setDateRange] = useState([
    new Date(moment().subtract(1, 'month')),
    new Date(moment()),
  ]);
  const [startDate, endDate] = dateRange;

  const checkDateFilter = (item) => {
    const { purchaseDate } = item;
    if (
      moment(purchaseDate).isSameOrAfter(moment(startDate)) &&
      moment(purchaseDate).isSameOrBefore(moment(endDate))
    ) {
      return true;
    }

    return false;
  };

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartV = document.getElementById('dvChartView');
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `${vendorNameMapping[vendor]} New/ Return Customer Report ${new Date().getFullYear()}`,
    })
    dvChartV.style.display = "block"; 
  }

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true;
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray =
        filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
        flag = false;
      }
    }

    if (flag) {
      flag = checkDateFilter(item);
    }
    return flag;
  };

  const callApi = () => {
    dispatch(handleLoader(true, vendor));
    dispatch(
      getNewReturnCustomerData({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        vendor
      }),
    );
  };

  const handleApplyDate = () => {
    callApi();
  };

  const viewReportButton = () => (
    <div className="view-report" style={{ zIndex: 2, top: '-10px', right: '0px' }}>
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        View Report
      </button>
    </div>
  );

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setNewReturnCustomerDataToShow(newReturnCustomerData?.modal?.data || []);
  }, [newReturnCustomerData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData]);

  const newReturnCustomerDataToShowForDatesSelected = newReturnCustomerDataToShow?.filter(item =>
    filterBasedOnFilter(item),
  );

  const dataToReport = [];
  const dataByDay = {};

  newReturnCustomerDataToShowForDatesSelected.forEach((item) => {
    if (item?.purchaseDate && dataByDay[item.purchaseDate]) {
      dataByDay[item.purchaseDate].push(item);
    } else {
      dataByDay[item.purchaseDate] = [item];
    }
  });
  const dataDays = Object.keys(dataByDay);

  dataDays.forEach((day) => {
    const purchaseDateData = dataByDay[day];

    const dataItem = {
      purchaseDate: day,
      "New Customers Count": 0,
      "Repeated Customers Count": 0,
      "% New Customer": 0,
      totalCustomerCount: 0
    }

    purchaseDateData.reduce((acc, item) => {
      const { newCustomersCount, repeatedCustomersCount, totalCustomerCount } = item

      acc["New Customers Count"] += Number(newCustomersCount);
      acc["Repeated Customers Count"] += Number(repeatedCustomersCount);
      acc.totalCustomerCount += Number(totalCustomerCount)
      return acc
    }, dataItem);

    dataItem['% New Customer'] = Number(dataItem.totalCustomerCount) ?
      ((Number(dataItem['New Customers Count']) / Number(dataItem.totalCustomerCount)) * 100).toFixed(2) : 0;

    dataToReport.push({
      ...dataItem
    })
  });
  return (
    <Container className="dashboard">
      <Row className="monthly-subscription-order">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">{vendorNameMapping[vendor]} New/ Return Customer </h5>
              </div>
              <Row className="align-items-center">

                <Col md="12">
                  <Row className="align-items-center">
                    <Col sm="4">
                      <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Date</span>
                        <div className="form__form-group-field">
                          <div className="date-picker">
                            <DatePicker
                              dateFormat="MM/dd/yyyy"
                              selectsRange
                              startDate={startDate}
                              endDate={endDate}
                              onChange={(update) => {
                                setDateRange(update);
                              }}
                              withPortal={isMobileOnly}
                              value={`${moment(startDate).format('MM/DD/YYYY')} - ${endDate ? moment(
                                endDate,
                              ).format('MM/DD/YYYY') : 'Select End Date'}`}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm="8" style={{ top: '10px' }}>
                      <button
                        className="btn btn-sm btn-primary apply-date-button"
                        type="button"
                        onClick={handleApplyDate}
                      >
                        Apply
                      </button>
                      <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div id="divToPrint" ref={container}>
      <Card className="pb-3">
        <CardBody className="">
          <Row className="show-sales-region">
            <Col md="12">
              <Card>
                <CardBody className="p-0">
                  <div className="top-location" style={{ minHeight: '400' }}>
                    <div>
                      {isLoading ? (
                        <div
                          style={{ minHeight: '200px' }}
                          className="row align-items-center justify-content-center"
                        >
                          <SmallLoader loading={isLoading} />
                        </div>
                      ) : (
                        <NewReturnCustomer
                          title="New/Return Customer"
                          viewReportButton={viewReportButton}
                          data={dataToReport}
                          dir={rtl.direction}
                        />
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardBody>
      </Card>
      </div>
      <ViewNewReturnReportModel
        data={dataToReport}
        isOpen={isOpen}
        handleModal={setIsOpen}
        title="New/ Return Customer"
        fileName="New/ Return Customer "
        tableHeaderData={tableNewReturnCustomer}
      />
    </Container>
  );
};

NewReturnCustomerIndex.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
  vendor: PropTypes.number.isRequired
};

export default 
  connect(state => ({
    rtl: state.rtl,
  }))(NewReturnCustomerIndex);
